export default __webpack_public_path__ + "static/media/Parallax-HUD-Altimeter.704a9516.jpg";